import '@core/interceptors/bpc-api-interceptors';
import { VueConstructor } from 'vue';
import PrintTemplateService from '@tools/services/print-template-service';
declare module 'vue/types/vue' {
  interface Vue {
    $printTemplateService: PrintTemplateService;
  }
}

export default class ToolsModule {
  static install(Vue: VueConstructor<Vue>): void {
    Vue.prototype.$printTemplateService = new PrintTemplateService();
    console.log('initiating Tools module');
  }
}
